import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

const useStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 18px',
    [theme.breakpoints.down('md')]: {
      padding: '10px 24px',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    width: 'fit-content',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '5px',
  },
};

export default useStyles;

export const BranchNameTextStyle = {
  fontSize: '16px',
  color: COLORS.black.dark,
};

export const BranchAddressTextStyle = {
  color: COLORS.gray.dark,
  fontSize: '16px',
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',

  '& svg': {
    marginTop: '-2px',
    strokeOpacity: '0.7',
    transform: 'scale(0.99)',
  },
};
